<main>
    <!-- <component-loader [active]="showLoader"></component-loader> -->
    <router-outlet></router-outlet>
</main>